/**
 * Build a CSV string from an array of objects given an ordered column spec.
 * spec: [{ key: string, header: string, get?: (row) => any }]
 * Triggers a browser download.
 */
function csvEscape(val) {
  if (val === null || val === undefined) return "";
  const s = String(val);
  if (s.includes('"') || s.includes(",") || s.includes("\n") || s.includes("\r")) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function downloadCsv(filename, spec, rows) {
  const header = spec.map((c) => csvEscape(c.header)).join(",");
  const body = rows
    .map((row) =>
      spec
        .map((c) => csvEscape(c.get ? c.get(row) : row[c.key]))
        .join(",")
    )
    .join("\r\n");
  // BOM so Excel opens UTF-8 correctly
  const csv = "\uFEFF" + header + "\r\n" + body + "\r\n";
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
